import { NewColor } from '@factorialco/f0-react'
import { ExpensesEntitiesExpensableStatusEnum } from 'generated/resources/graphql'

export function getF1StatusColor(status: ExpensesEntitiesExpensableStatusEnum): NewColor {
  const colors: Record<string, NewColor> = {
    ['approved']: 'viridian',
    ['in_payroll']: 'indigo',
    ['sent_to_pay']: 'purple',
    ['rejected']: 'lilac',
    ['pending']: 'yellow',
    ['draft']: 'smoke',
    ['reversed']: 'barbie',
    ['manual']: 'viridian',
    ['automatic']: 'purple',
    ['paid']: 'malibu',
    ['changes_requested']: 'camel',
  }

  return colors[status] ?? 'smoke'
}
